export default "__VITE_ASSET__PT8rChYG__"